module.exports = __webpack_public_path__ + "6c9e9333dae368ee3e80d7ecdec79bcb.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2020-01-21/whats-new.html
// module id = 1910
// module chunks = 0